import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import MainSection from "../../components/mainLayout/Main";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";
import { useNavigate, useParams } from "react-router-dom";
import { getOneSubClient } from "../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";



const data = [];
for (let i = 1; i <= 100; i++) {
	// Add more rows for demo
	data.push({
		key: i,
		name: `John Brown ${i}`,
		age: Number(`${i}2`),
		address: `New York No. ${i} Lake Park`,
	});
}

const ViewSubClient = () => {
	// Initialize DataTable on mount

	const dispatch = useDispatch();
	const { id } = useParams();
	const navigate = useNavigate();

	const subClient = useSelector((state) => state.auth.subClient);




	const [formData, setFormData] = useState({
		name: "",
		email: "",
		clientType: "",
		phoneNumber: "",
		opted: []
	});

	useEffect(() => {
		async function func() {
			try {
				const token = localStorage.getItem("token");
				if (token) {
					await dispatch(getOneSubClient(id));
				}
			} catch (err) {
				console.error(err);
			}
		}
		func();
	}, [dispatch, id]);




	useEffect(() => {
		setFormData({
			name: subClient?.name,
			email: subClient?.email,
			clientType: subClient?.clientType,
			phoneNumber: subClient?.phoneNumber,
			opted: subClient?.services?.map((service) => (service.name)), // Convert existing opted array to React-Select format
		});
	}, [subClient]);




	
	const handleEdit = async (e) => {
		navigate(`/client-management/edit-client/edit-subclient/${id}`);
	};

	const handleBack = () => {
		navigate(`/client-management`);
	};

	useEffect(() => {
		console.log(formData.opted);
	}, [formData]);

	return (
		<div>
			<Sidebar />

			<MainSection>
				<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
					<div className="col-span-1 border-r pr-4 ">
						<SectionHeader title="View Sub-Client" />

						<div className="container w-full text-start">
							<div class="my-5">
								<label
									for="email"
									class="block mb-2 text-sm font-medium text-gray-900 "
								>
									Client Name
								</label>
								<input
									type="text"
									id="name"
									value={formData.name}
									disabled
									//onChange={handleChange}
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
									placeholder="Enter Client name"
									required
								/>
							</div>

							<div class="mb-5">
								<label
									for="email"
									class="block mb-2 text-sm font-medium text-gray-900 "
								>
									Email Address
								</label>
								<input
									type="email"
									id="email"
									value={formData.email}
									// onChange={handleChange}
									disabled
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
									placeholder="Enter email address"
									required
								/>
							</div>

							<div className="mb-5">
								<label
									for="clientType"
									class="block mb-2 text-sm font-medium text-gray-900 "
								>
									Client Type
								</label>
								<input
									type="text	"
									id="clientType"
									value={formData?.clientType}
									//onChange={handleChange}
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
									placeholder="Enter Phone number"
								/>
							</div>

							<div class="mb-5">
								<label
									for="phoneNumber"
									class="block mb-2 text-sm font-medium text-gray-900 "
								>
									Phone Number
								</label>
								<input
									type="Number"
									id="phoneNumber"
									value={formData.phoneNumber}
									//onChange={handleChange}
									disabled
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
									placeholder="Enter Phone number"
									required
								/>
							</div>

							<div className="mb-5">
								<label
									for="service"
									class="block mb-2 text-sm font-medium text-gray-900 "
								>
									Services
								</label>
								<input
									type="text	"
									id="services"
									value={formData?.opted?.join(",")}
									//onChange={handleChange}
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
									placeholder="Enter Phone number"
									disabled
								/>
							</div>

							<div className="space-y-4">
								<button
									onClick={handleEdit}
									className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-[#045B9B] hover:bg-[#3385c0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
								>
									Edit Sub-Client
								</button>
							</div>

							<div className="mt-4">
								<button
									className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-[#045B9B] hover:bg-[#3385c0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
									onClick={handleBack}
								>
									Back
								</button>
							</div>
						</div>

					</div>
				</div>
			</MainSection >
		</div >
	);
};

export default ViewSubClient;
